import * as React from 'react';
export var BreadcrumbsItem = function (_a) {
    var children = _a.children, isCurrentLinkActive = _a.isCurrentLinkActive, isCurrentPage = _a.isCurrentPage;
    var renderChildren = function () {
        return React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                var elementChild = child;
                return React.cloneElement(elementChild, {
                    'aria-current': isCurrentPage ? 'page' : undefined,
                    role: !isCurrentLinkActive && isCurrentPage ? 'presentation' : undefined,
                    tabIndex: !isCurrentLinkActive && isCurrentPage ? '-1' : undefined,
                    href: !isCurrentLinkActive && isCurrentPage ? undefined : child.props.href,
                });
            }
            return children;
        });
    };
    return React.createElement(React.Fragment, null, renderChildren());
};
BreadcrumbsItem.propTypes = {
    children: function (props, propName, componentName) {
        var prop = props[propName];
        var error = null;
        React.Children.forEach(prop, function (child) {
            if (child.type !== 'a') {
                error = new Error("For accessibility, ".concat(componentName, " active children must be an anchor element."));
            }
        });
        return error;
    },
};
export var isABreadcrumbItem = function (child) {
    if (React.isValidElement(child)) {
        // Check non-optional properties of BreadcrumbsItemProps
        return 'label' in child.props && 'isCurrentPage' in child.props;
    }
    return false;
};
export default BreadcrumbsItem;
//# sourceMappingURL=BreadcrumbsItem.js.map